<template>
  <div class="app">
    <AppHeader />

    <main class="p-4">
      <RouterView @setReminder="onSetReminder" />
    </main>

    <VDialog
      v-model="isDialogOpen"
      :classes="{ content: 'radius-1 p-3 bg-white' }"
    >
      <h2 class="size-5 text-center">Did you apply?</h2>
      <p>
        Set yourself a reminder to check in on it when the bonus time comes.
      </p>
      <div class="flex justify-content-between">
        <a :href="reminders.google" class="btn" target="_blank">Google</a>
        <a :href="reminders.ics" class="btn" target="_blank">ICS</a>
      </div>
    </VDialog>
  </div>
</template>

<script>
import { API, STRIPE_PUBLIC } from "./config"
import calendar from "@/calendar"
import store from "@/store"
import AppHeader from "@/components/AppHeader"
import http from "@/http"

export default {
  components: {
    AppHeader,
  },

  data: () => ({
    isDialogOpen: false,
    reminders: {},
  }),

  mounted() {
    const loggedIn = localStorage.getItem("loggedIn")
    if (!loggedIn) return

    http
      .get(`${API}/refresh-token`, { credentials: "include" })
      .then(data => {
        store.set.user(data.user)
        store.set.auth(data.auth)
        store.actions.refreshToken()
      })
      .catch(() => {})
  },

  methods: {
    onSetReminder({ title, timeframe }) {
      this.isDialogOpen = true

      const event = {
        title: `Check on ${title}`,
        // description: "Some event description",
        start: Date.now() + 1000 * 60 * 60 * 24 * 30 * timeframe,
        duration: 1000,
      }

      this.reminders = {
        google: calendar.google(event),
        ics: calendar.ics(event),
      }
    },
  },
}
</script>

<style lang="scss">
.app {
  display: grid;
  grid-template-columns: auto 1fr;
  min-height: 100vh;
}
</style>
